import { useState } from 'react'
import { DateTime } from 'luxon'
import { useQuery, useQueryClient } from 'react-query'
import { TimeRangeEnum, timeRangeValue } from '@interfaces/TimeRangeEnum'
import { SalesReportSearchFormType } from '@models/salse/SalesReportSearchFormType'
import { useAuthentication } from '@hooks/useAuthentication'
import { useClient } from '@hooks/useClient'
import { useAlert } from '@hooks/useAlert'
import { getErrorMessage } from '@libs/utils'
import { SaleReportQueryParam, SalesReportPageProps } from './interface'

export function withSalesReportPage(Component: React.FC<SalesReportPageProps>) {
  function WithSalesReportPage() {
    const client = useClient()
    const queryClient = useQueryClient()
    const { isAuthenticated } = useAuthentication()
    const alert = useAlert()
    const [searchParam, setSearchParam] = useState<SaleReportQueryParam>({})

    function formatDate({
      timeRange,
      startAt,
      endAt,
    }: SalesReportSearchFormType) {
      let newStartAt = startAt
        ? DateTime.fromJSDate(startAt).startOf('day')
        : undefined
      let newEndAt = endAt ? DateTime.fromJSDate(endAt).endOf('day') : undefined

      if (timeRange === TimeRangeEnum.DAY) {
        newStartAt = DateTime.now().startOf('day')
        newEndAt = DateTime.now().endOf('day')
      } else if (timeRange === TimeRangeEnum.MONTH) {
        newStartAt = DateTime.now()
          .minus({ day: timeRangeValue[TimeRangeEnum.MONTH] })
          .startOf('day')
        newEndAt = DateTime.now().endOf('day')
      }
      // else if (timeRange === TimeRangeEnum.YEAR) {
      //   newStartAt = DateTime.now()
      //     .minus({ day: timeRangeValue[TimeRangeEnum.YEAR] })
      //     .startOf('day')
      //   newEndAt = DateTime.now().endOf('day')
      // }
      return { timeRange, startAt: newStartAt, endAt: newEndAt }
    }

    async function handleSubmit(form: SalesReportSearchFormType) {
      const selectedDate = formatDate(form)
      if (selectedDate.startAt && selectedDate.endAt) {
        // Check if the date range exceeds 90 days
        const startDate = selectedDate.startAt.toJSDate()
        const endDate = selectedDate.endAt.toJSDate()
        const diffTime = Math.abs(endDate.getTime() - startDate.getTime())
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

        if (diffDays > 90) {
          alert.error('ช่วงเวลาที่เลือกต้องไม่เกิน 90 วัน')
          return
        }

        setSearchParam({
          timeRange: selectedDate.timeRange,
          startAt: selectedDate.startAt,
          endAt: selectedDate.endAt,
        })
      }
    }

    async function handleReset() {
      setSearchParam({
        timeRange: TimeRangeEnum.MONTH,
        startAt: undefined,
        endAt: undefined,
      })
    }

    // const { data: purchaseProportion = [] } = useQuery(
    //   ['purchase-proportion', searchParam],
    //   () => {
    //     if (searchParam.submit) {
    //       return client?.saleClient.getPurchaseProportion({
    //         searchParam,
    //       })
    //     }
    //     return Promise.resolve([])
    //   },
    //   {
    //     enabled: isAuthenticated,
    //   }
    // )

    // const { data: salesReportsOverview } = useQuery(
    //   ['sales-reports-overview', searchParam],
    //   () =>
    //     client?.saleClient.getSalesReportsOverview({
    //       searchParam,
    //     }),
    //   {
    //     enabled: isAuthenticated,
    //   }
    // )

    async function handleExport() {
      try {
        if (!searchParam.startAt || !searchParam.endAt) {
          return
        }
        await client?.saleClient.exportSalesReports({
          startDate: searchParam.startAt?.toUTC(),
          endDate: searchParam.endAt?.toUTC(),
        })
        await queryClient.refetchQueries('export-jobs')
      } catch (e) {
        alert.error(getErrorMessage(e))
      }
    }

    const data = {
      downloadTotal: 0,
      remainCoin: 0,
      salesSystem: 0,
      donateSystem: 0,
      shareSystem: 0,
      activeUser: 0,
      salesTotal: 0,
      amountTotal: 0,
      donateTotal: 0,
      purchaseProportion: [],
    }

    const newProps = {
      data,
      searchParam,
      handleSubmit,
      handleExport: undefined,
      handleReset,
    }
    return <Component {...newProps} />
  }

  return WithSalesReportPage
}
